(() => {
  'use strict';
  if (document.documentElement.hasAttribute('data-skn-buttons-ready')) return;
  document.documentElement.setAttribute('data-skn-buttons-ready', '');
  const selector = '.skn-design-system :is(.button, .shopify-challenge__button, .sk-cta, .sk-cta-secondary, .sk-primary, .sk-outline, .sk-floating-purchase__button, .skn-launch-signup__submit):not(:disabled):not([aria-disabled="true"]):not(.shopify-payment-button__button)';
  const hoverAvailable = matchMedia('(hover: hover) and (pointer: fine)');

  function edgeClip(button, event) {
    const rect = button.getBoundingClientRect();
    const distances = [
      [Math.abs(event.clientY - rect.top), 'inset(0 0 100% 0)'],
      [Math.abs(event.clientX - rect.right), 'inset(0 0 0 100%)'],
      [Math.abs(event.clientY - rect.bottom), 'inset(100% 0 0 0)'],
      [Math.abs(event.clientX - rect.left), 'inset(0 100% 0 0)']
    ];
    return distances.reduce((nearest, candidate) => candidate[0] < nearest[0] ? candidate : nearest)[1];
  }

  document.addEventListener('pointerover', (event) => {
    if (!hoverAvailable.matches || event.pointerType === 'touch') return;
    const button = event.target instanceof Element ? event.target.closest(selector) : null;
    if (!button || button.contains(event.relatedTarget)) return;
    button.style.setProperty('--skn-button-clip', edgeClip(button, event));
    getComputedStyle(button, '::before').clipPath;
    button.classList.add('skn-button-hover');
  });

  document.addEventListener('pointerout', (event) => {
    const button = event.target instanceof Element ? event.target.closest('.skn-button-hover') : null;
    if (!button || button.contains(event.relatedTarget)) return;
    button.style.setProperty('--skn-button-clip', edgeClip(button, event));
    button.classList.remove('skn-button-hover');
  });

  hoverAvailable.addEventListener('change', () => {
    if (!hoverAvailable.matches) document.querySelectorAll('.skn-button-hover').forEach(button => button.classList.remove('skn-button-hover'));
  });
})();
